import { Component, Input, OnInit } from '@angular/core';
import { Promo } from '../../interfaces/Promo';
import { PromoService } from '../../services/promo.service';
import * as moment_ from 'moment';
//UTILS
import { mountCdnPath } from "../../utils/images"

const moment = moment_;

@Component({
  selector: 'ng-promo-details',
  styleUrls: ['./promo-details.component.scss'],
  template: `
    <div class="card card-yellow no-padding" [ngClass]="{'card-modal': isModal}" *ngIf="promo">
      <div class="card-content">
        <header>
          <img *ngIf="showImage" alt="Sorteio" [src]="this.imageSrcPromo"/>
          <h2>{{ promo?.title }}</h2>
          <p>
            <i class="fa fa-clock-o" aria-hidden="true"></i> {{ differenceDays }} dias restantes
          </p>
        </header>
        <p [innerHTML]="promo?.description"></p>
        <footer class="text-center">
          <button [disabled]="disableButton" class="btn" type="button" (click)="participate(promo?.id)">
            {{ buttonText }}
          </button>
          <p class="promo-info" *ngIf="!alreadyParticipating && reachLimit">Prêmios esgotados. :( Quem sabe na próxima?</p>
          <p class="promo-info" *ngIf="error">{{error}}</p>
        </footer>

        <ng-core-loading *ngIf="loading"></ng-core-loading>
      </div>
    </div>
  `
})
export class PromoDetailsComponent implements OnInit {

  @Input() promo: Promo;
  @Input() isModal = false;
  @Input() showImage = true;

  error: string;
  loading = true;
  reachLimit = false;
  disableButton = true;
  alreadyParticipating: boolean;
  couponModalData: object;
  imageSrcPromo: string;

  constructor(private promoService: PromoService) {}

  ngOnInit() {
    this.checkPromoStatus();

    this.imageSrcPromo = mountCdnPath(this.promo.image_key);

    this.reachLimit = this.promo.prizeDrawType === 'clickWin' && this.promo.params.status === 'reachLimit';
  }

  get differenceDays() {
    return this.promo.end_date ? moment(this.promo.end_date).diff(moment(), 'days') : null;
  }

  get buttonText() {
    const { prizeDrawType } = this.promo;
    switch (prizeDrawType) {
      case 'clickWin': {
        return this.alreadyParticipating ? 'Você ganhou! Confira seu email' : 'Clique e ganhe';
      }
      case 'subscribe': {
        return this.alreadyParticipating ? 'Você está participando' : 'Clique e participe';
      }
      case 'externalLink': {
        return 'Acesse o link para participar';
      }
    }
  }

  checkButtonStatus() {
    this.disableButton = this.promo.prizeDrawType === 'externalLink' ? false : this.alreadyParticipating || this.reachLimit;
  }

  participate(promoId) {
    this.error = null;
    this.loading = true;

    if (!this.alreadyParticipating) {
      this.promoService.participate(promoId).subscribe(() => {
        this.alreadyParticipating = true;
        this.loading = false;
        this.checkButtonStatus();
      }, ({error}) => {
        this.handleError(error);
        this.loading = false;
      });
    }

    if (this.promo.prizeDrawType === 'externalLink') {
      this.loading = false;
      window.open(`${this.promo.params.externalUrl}`, '_blank');
    }
  }

  checkPromoStatus() {
    this.loading = true;

    this.promoService.verify(this.promo.id).subscribe(coupon => {
      this.loading = false;
      this.alreadyParticipating = coupon.statusCode === 200;
      this.checkButtonStatus();
    }, () => {
      this.error = 'Houve um erro ao checar o status da promoção. Por favor, tente novamente.';
      this.disableButton = true;
      this.loading = false;
    });
  }

  handleError(res) {
    switch (res && res.error && res.error.message) {
      case 'User already participating': {
        this.error = 'Você já está participando deste sorteio.';
        this.alreadyParticipating = true;
        this.disableButton = true;
        break;
      }
      case 'PrizeDraw reach limit participates': {
        this.reachLimit = true;
        break;
      }
      default: {
        this.error = 'Ocorreu um erro ao participar do sorteio. Entre em contato com o suporte ou tente novamente.';
      }
    }
  }
}
